import React from 'react';

function Badges({text, color}) {
    return (
        <div className={`w-9/12 bg-${color} h-14 rounded-lg text-white font-bold flex items-center text-2xl flex justify-center items-center`}>
            {text}
        </div>
    );
}

export default Badges;